import { gql } from '@apollo/client'
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core'

import { ProductPreviewProductFragmentDoc } from './ProductPreviewProduct.generated'
import * as Types from './purchasePlus_graphql'

export const GetProductOutOfStockModalDocument = gql`
  query GetProductOutOfStockModal($id: Int!) {
    product(id: $id) {
      ...ProductPreviewProduct
      canonicalProductId
      outOfStock
      owner {
        id
        name
      }
    }
  }
  ${ProductPreviewProductFragmentDoc}
` as unknown as DocumentNode<Types.GetProductOutOfStockModalQuery, Types.GetProductOutOfStockModalQueryVariables>
